// loan-features.js
import React from 'react';
import './loan-features.css';
import { ClockFill, ShieldLockFill, GraphUp, WalletFill } from 'react-bootstrap-icons';

const featuresData = [
    { 
        id: 1, 
        icon: <ClockFill />, 
        title: "Instant Application Review", 
        detail: "Your loan request is reviewed quickly with transparent evaluation parameters—no false commitments, no hidden steps."
    },
    { 
        id: 2, 
        icon: <ShieldLockFill />, 
        title: "Secure Data Protection", 
        detail: "Your documents and personal information are fully encrypted and processed under strict security standards."
    },
    { 
        id: 3, 
        icon: <GraphUp />, 
        title: "Flexible Loan Options", 
        detail: "Choose from multiple loan types designed to suit individual income profiles and repayment capacities."
    },
    { 
        id: 4, 
        icon: <WalletFill />, 
        title: "Fast & Simple Disbursement", 
        detail: "Once approved, funds are transferred seamlessly to your bank account with a smooth, hassle-free process."
    }
];

const LoanFeatures = () => {
    return (
        <section className="tilted-section py-4 py-md-5">
            
            {/* Background Animation (as per your original requirement) */}
            <div className="data-ripple-bg"></div>

            <div className="container position-relative z-index-10">

               <h2 className="display-4 feature-title text-dark">
                    Key Features : <span className="feature-secondary-info">That Your Financial Confidence</span>
                </h2>

                <div className="row justify-content-center tilted-slates-row">
                    {featuresData.map((feature) => (
                        <div key={feature.id} className="col-lg-3 col-md-6 mb-4 d-flex justify-content-center">
                            
                            {/* Tilted Card */}
                            <div className="tilted-slate">
                                
                                <div className="slate-bg-shape"></div>

                                <span className="slate-number">{`0${feature.id}`}</span>

                                <div className="slate-content">
                                    <div className="slate-icon-box">
                                        {feature.icon}
                                    </div>

                                    <h3 className="slate-title">{feature.title}</h3>
                                    <p className="slate-detail">{feature.detail}</p>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LoanFeatures;
